import styled from 'styled-components';
import { StyledComponentsPropWithTheme } from 'src/commons/components/ChromeApp/ChromeAppUtils';

interface SectionNavContainerProps extends StyledComponentsPropWithTheme {
  isMobile?: boolean;
}

export const SectionNavContainer = styled.div<SectionNavContainerProps>`
  background: ${(props: StyledComponentsPropWithTheme) =>
    props.theme.header.sectionNav.background};
  border-top: 1px solid ${({ theme }) => theme.color.gray[100]};

  & nav {
    padding-inline-start: ${({ theme }) => theme.spacing.small.mobile};
  }
`;
